import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Tooltip } from '@delmonicos/shared-design-system-react/src/components/tooltip/tooltip';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface CustomerListIdCellProps
  extends CellContext<GatewayCustomerModel, GatewayCustomerModel['id']> {}

export const CustomerListIdCell = (
  props: CustomerListIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.CUSTOMER.DETAILS, { id: row.original.id }),
        )
      }
      fullWidth>
      <Tooltip content={getValue()}>
        <Text>{getValue().split('-')[0]}</Text>
      </Tooltip>
    </Link>
  );
};
